import { Link } from "react-router-dom";
import { Database } from "lucide-react";
import { statusSeverity } from "@/lib/formatMarket";
import { StatusBadge, statusToneStyle } from "@/components/wheel/StatusBadge";

// Do not default to "Delayed" or claim a 15-minute cadence from provider identity.
const FALLBACK_LABEL = "Cache-backed";

function chainSourceTier(source) {
  const label = source?.user_label || source?.label || source?.banner || FALLBACK_LABEL;
  return statusSeverity(label, { status: source?.status });
}

export function ChainSourceBadge({ source }) {
  if (!source) return null;
  const label = source?.user_label || source?.label || FALLBACK_LABEL;
  return (
    <StatusBadge
      testid="chain-source-badge"
      tier={chainSourceTier(source)}
      text={`Options chain: ${label}`}
      title={source?.banner || source?.user_label || "Option snapshots are cache-backed, never live. Status follows stored timestamps, not provider brand."}
    />
  );
}

export function ChainSourceBanner({ source }) {
  if (!source) return null;
  const tier = chainSourceTier(source);
  const tone = statusToneStyle(tier);
  const quiet = tier === "info";
  return (
    <div
      data-testid="chain-source-banner"
      className="flex items-center gap-2 px-4 py-2 mb-4 rounded-md border text-[12px]"
      style={{
        borderColor: quiet ? "var(--hoip-border)" : tone.borderColor,
        background: quiet ? "transparent" : tone.background,
        color: quiet ? "var(--hoip-text-secondary)" : tone.color,
      }}
    >
      <Database className="w-4 h-4 flex-shrink-0" />
      <span>
        {source?.banner || "Market data is cache-backed — not live pricing."}{" "}
        <Link to="/profile?tab=brokers" className="underline font-medium" data-testid="chain-banner-settings-link">
          Connect a broker for live pricing
        </Link>
        .
      </span>
    </div>
  );
}
